// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1e76G","footer":"styles_footer__3uAq3"};